import { tabAccessControl } from "../../../_helpers/access-control";

let CustomerTabs = [
  {
    text: "All",
    path: `/customer`,
    applicationFeatureCode: "Customer",
  },
  {
    text: "Delivery Addresses",
    path: `/delivery-address`,
    applicationFeatureCode: "CustomerDeliveryAddress",
  },
  {
    text: "Transactions",
    path: `/customer-transaction`,
    applicationFeatureCode: "CustomerTransactionHistory",
  },
  {
    text: "Statements",
    path: `/customer-statement`,
    applicationFeatureCode: "ReportCustomerStatement",
  },
  {
    text: "Call Logs",
    path: `/call-logs`,
    applicationFeatureCode: "CallLogs",
  },
  {
    text: "Surveys",
    path: `/surveys`,
    applicationFeatureCode: "SurveyResponse",
  },
  {
    text: "Sample Requests",
    path: `/customer-sample-requests`,
    applicationFeatureCode: "SampleRequests",
  },
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(CustomerTabs).findIndex((x) => x.text == tabName);
}

export { CustomerTabs, GetIndexByTabName };
